import Api from '@/api/index'

// Los reportes no se cachean en el store: cada vista pide con sus propios
// filtros y consume la respuesta directamente. El módulo existe para que las
// vistas hablen con `dispatch` como el resto de la app, no con la API cruda.
const state = {}

const getters = {}

const ACTIONS = [
  'getCarteraPendiente',
  'getVencimientos',
  'getClientes',
  'getRechazos',
]

// El contexto de Vuex no se usa: los reportes no mutan estado, sólo devuelven
// la respuesta a la vista que los pidió.
const actions = ACTIONS.reduce(
  (map, name) =>
    Object.assign(map, {
      [name]: async (context, params) => {
        const data = await Api.Report[name](params)
        return data !== null ? data : null
      },
    }),
  {}
)

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
